import $ from 'jquery'
import _ from 'underscore'
import StateManager from '../scuba/StateManager'

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
  $(node)
    .find('.js-sticky')
    .each(function(i, el) {
      new Sticky(el)
    })
})

/* --------------------------------------------------
    CLASS
-------------------------------------------------- */

function Sticky() {
  this.initialize.apply(this, arguments)
}

$.extend(Sticky.prototype, {
  initialize: function(el) {
    const self = this
    self.uid = _.uniqueId('scuba-')
    self.$el = $(el)
    self.$parent = self.$el.parent()
    self.$sectionContent = self.$el.closest('.js-scuba__content')
    self.$scrollParent = $(el).closest('.js-scuba__section')
    self.$body = $(el).closest('.js-scuba__section__body')

    self.invalidatePosition = _.throttle(self.invalidatePosition.bind(this), 30)
    self.fixIt = self.fixIt.bind(this)
    self.unfixIt = self.unfixIt.bind(this)

    self.$sectionContent.on('widthChanged', self.invalidatePosition)
    $(window).on('resize', self.invalidatePosition)

    self.$scrollParent.on('scroll', self.invalidatePosition)
  },
  invalidatePosition: function() {
    const self = this
    if (self.$parent.offset().top <= 0) {
      self.fixIt()
    } else {
      self.unfixIt()
    }
  },
  fixIt: function() {
    const self = this
    const maxTop = self.$body.height() - self.$el.height()
    self.$el.css(
      self.$body.length && self.$parent.offset().top + maxTop < 0
        ? {
            position: 'absolute',
            top: maxTop,
            left: 0,
            zIndex: 1,
            width: self.$parent.width()
          }
        : {
            position: 'fixed',
            top: 0,
            zIndex: 1,
            left: self.$parent.get(0).getBoundingClientRect().left,
            width: self.$parent.width()
          }
    )
  },
  unfixIt: function() {
    const self = this
    self.$el.css({
      position: 'relative',
      top: 'auto',
      zIndex: 0,
      left: 'auto',
      width: 'auto'
    })
  }
})



// WEBPACK FOOTER //
// ./scripts/components/Sticky.js